import { Router } from '@angular/router';
import { FunctionsService, HttpService, LocalStorageService } from 'brainloper-ui';
import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Notification } from 'app/models2/notification/notification';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { NotificationsService } from 'app/services/notifications.service';
import { SocketWebService } from 'app/services/socket-web.service';
import { Subscription } from 'rxjs';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { DataDashboard } from 'app/models2/maintenance/data-dashboard';
import { INotificationByCompany } from 'app/models2/maintenance/notification-by-company';

@Component({
  selector: 'app-inital-page-desktop',
  templateUrl: './inital-page-desktop.component.html',
  styleUrls: ['./inital-page-desktop.component.scss']
})
export class InitalPageDesktopComponent implements OnInit, OnDestroy {


  private urlDataDashboard = `${EndpointDictionary.Indicator.INDICATOR_DATA_DASHBOARD}`
  public dataDashboard:DataDashboard = new DataDashboard()
  public notifications:Array<Notification> = []
  public today:string = ''
  public subscriptionNotified:Subscription
  public subscriptionNotifiedByRol:Subscription
  constructor(
    private functionEter : FunctionsService,
    private http : HttpService,
    public router : Router,
    private notificationServices : NotificationsService,
    private storage : LocalStorageService,
    private socketWebService : SocketWebService,
    private utils : UtilsServiceService
  ) { }

  ngOnInit(): void {
    this.today = this.functionEter.dateDB(new Date())
    this.getDataDashboard()
    this.updateNotification()
  }

  async getDataDashboard(){
    this.dataDashboard  = await this.http.getDataBody<DataDashboard>(this.urlDataDashboard)
  }

  async updateNotification(){
    this.subscriptionNotified = this.socketWebService.listen('notified').subscribe(async (data: INotificationByCompany) => {
      if(data.userId === this.storage.get('userId').toString() && data.companyId === this.storage.get('companyId').toString()){
        await this.getNotification()
      }
    })

    this.subscriptionNotifiedByRol = this.socketWebService.listen('notified-by-rol').subscribe(async (data: INotificationByCompany) => {
      if (data.roleId === this.storage.get('roleId').toString() && data.companyId === this.storage.get('companyId').toString()) {
        await this.getNotification()
      }
    })

    if(this.notifications.length == 0) await this.getNotification()
    }

  async getNotification(){
    this.notifications = await this.notificationServices.getNotifications()
  }

  refreshDashboard(){
    this.getDataDashboard()
  }

  redirect(router:string){
    let url = this.utils.getQueryParams(router)
      this.router.navigate([url.url], {
        queryParams: url.params,
      });
  }

  handlerNotification(item:Notification){
    this.notificationServices.handlerNotification(item)
  }

  ngOnDestroy(){
  this.subscriptionNotified.unsubscribe()
  this.subscriptionNotifiedByRol.unsubscribe()
  }

}
